import { render, staticRenderFns } from "./index.vue?vue&type=template&id=906eee20&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=906eee20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906eee20",
  null
  
)

export default component.exports